// src/components/Layout.js
import React, { useState } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import '../styles/layout.css';

function Layout({ onLogout, user }) {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  // ✅ Cierra el menú móvil al seleccionar una opción
  const closeMenu = () => {
    setIsOpen(false);
  };

  // ✅ Logout seguro (usa onLogout si existe; si no, hace fallback)
  const handleLogout = () => {
    closeMenu();

    if (typeof onLogout === 'function') {
      onLogout();
      return;
    }

    // Fallback: borra token y manda al login
    localStorage.removeItem('token');
    navigate('/login'); // cambia a '/login' si tu login está en otra ruta
  };

  return (
    <div className="layout-wrapper">
      {/* Header móvil */}
      <header className="mobile-header">
        <button className="hamburger" onClick={toggleMenu}>
          ☰
        </button>
        <h1 className="mobile-title">Floristería2000</h1>
      </header>

      {/* Sidebar */}
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <a href="https://pos.floristeria2000.com/" target="_blank" rel="noreferrer">
            <img
              src="https://floristeria2000.com/wp-content/uploads/2020/12/LOGOFF.webp"
              alt="Logo"
              className="sidebar-logo"
            />
          </a>
        </div>

        <ul className="sidebar-menu">
          <li>
            <Link to="/" onClick={closeMenu}>Home</Link>
          </li>
          <li>
            <Link to="/pedidoregister" onClick={closeMenu}>Registrar Nuevo Pedido</Link>
          </li>
          <li>
            <Link to="/orders" onClick={closeMenu}>Pedidos Activos</Link>
          </li>
          <li>
            <Link to="/notes" onClick={closeMenu}>Notas</Link>
          </li>
          <li>
            <Link to="/accounts-receivable" onClick={closeMenu}>Cuentas por Cobrar</Link>
          </li>
          <li>
            <Link to="/AccountsPayable" onClick={closeMenu}>Cuentas por Pagar</Link>
          </li>
          <li>
            <Link to="/payable-bills" onClick={closeMenu}>Administración de Facturas</Link>
          </li>
          <li>
            <Link to="/CierreDeCaja" onClick={closeMenu}>Cierre de Caja</Link>
          </li>
        </ul>

        <div className="sidebar-footer">
          {user && <small>{user.nombre?.toUpperCase()}</small>}
          <button onClick={handleLogout}>Cerrar sesión</button>
        </div>
      </aside>

      {/* Main */}
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;
